var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoruCozum = function SvgSoruCozum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_4131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183 248.147V166C183 154.954 191.954 146 203 146H252.572C268.14 146 277.739 163.004 269.695 176.333L220.124 258.481C209.657 275.825 183 268.405 183 248.147Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 71C25 48.9086 42.9086 31 65 31H235C257.091 31 275 48.9086 275 71V157C275 179.091 257.091 197 235 197H65C42.9086 197 25 179.091 25 157V71Z",
    fill: "url(#paint0_linear_4330_4131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 109C85.5391 109 103 91.5391 103 70C103 48.4609 85.5391 31 64 31C42.4609 31 25 48.4609 25 70C25 91.5391 42.4609 109 64 109Z",
    fill: "#2B81FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4131",
    x1: 274.957,
    y1: 31.0076,
    x2: 121.994,
    y2: 261.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_4131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
export default SvgSoruCozum;